import { useNavigate, useSearchParams } from 'react-router-dom'
import { Badge, Link, Tab, Tabs, Typography } from '@mui/material'
import translate from '../../i18n/translate'
import { robotSmsPolicyApi } from '../../modules/services/robotSmsPolicyService'
import DeclarationsTab from './DeclarationsTab'
import PolicyVersionsTab from './PolicyVersionsTab'
import useStyles from './useStyles'

const TABS = ['versions', 'declarations'] as const

type PolicyTab = typeof TABS[number]

// Robot SMS custom lists declaration: document versions and the declarations organizers signed
const RobotSmsPolicyScreen = () => {
  const classes = useStyles()
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()

  const tab: PolicyTab = searchParams.get('tab') === 'declarations' ? 'declarations' : 'versions'

  // Only the pending counter is needed for the tab badge
  const { data: pending } = robotSmsPolicyApi.useGetRobotSmsDeclarationsQuery({ skip: 0, take: 1, status: 'pending' })

  return (
    <div className={classes.Wrapper}>
      <div className={classes.TopRow}>
        <Link color="#fc7f03" className={classes.ToMain} onClick={() => navigate('/')}>
          {translate('commonBackToTheMainPage')}
        </Link>
        <Typography variant="h6">{translate('robotSmsPolicyTitle')}</Typography>
      </div>

      <Tabs
      color="#fc7f03"
        value={tab}
        onChange={(_, value: PolicyTab) => setSearchParams(value === 'versions' ? {} : { tab: value })}
        sx={{ ml: 1, mb: 1, '& .MuiTab-root': { color: 'warning.main' }, '& .Mui-selected': { color: 'warning.dark !important' } }}
        TabIndicatorProps={{ sx: { backgroundColor: 'warning.main' } }}
      >
        <Tab value="versions" label={translate('robotSmsPolicyTabVersions')} />
        <Tab
          value="declarations"
          label={
            <Badge color="warning" badgeContent={pending?.pendingCount || 0} className={classes.TabBadge}>
              {translate('robotSmsPolicyTabDeclarations')}
            </Badge>
          }
        />
      </Tabs>

      {tab === 'versions' ? <PolicyVersionsTab /> : <DeclarationsTab />}
    </div>
  )
}

export default RobotSmsPolicyScreen
